import dedent from 'ts-dedent'
import {
  Provider,
  QueryAndOutputs,
  WorkflowCodeType,
  WorkflowComponentCodeParams,
  WorkflowComponentOutputType,
  WorkflowComponentParamType
} from '../types'
import { WorkflowComponent } from './common/workflowcomponent'

class ReadQuery extends WorkflowComponent {
  public static readonly NAME = 'native.readquery'
  constructor() {
    super(
      {
        name: ReadQuery.NAME,
        group: '__internal',
        title: 'Read Query',
        description: ''
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.String,
          title: 'Source query'
        },
        {
          name: 'tags',
          type: WorkflowComponentParamType.String,
          title: 'Tags',
          default: '',
          optional: true
        }
      ],
      [
        {
          name: 'out',
          title: 'View',
          description: 'The output view',
          type: WorkflowComponentOutputType.View
        }
      ]
    )
    this.hidden = true
  }

  async getCode({
    workflow,
    params,
    connection,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    let viewname
    let query
    if (codeType === WorkflowCodeType.DryRun) {
      const viewnameDryRun = connection.getOutputViewName(
        workflow.id,
        componentName,
        params,
        'out',
        WorkflowCodeType.DryRun
      )
      const queryDryRun = this.getInnerSql({
        params,
        connection,
        viewname: viewnameDryRun,
        codeType: WorkflowCodeType.DryRun
      } as WorkflowComponentCodeParams)
      const viewnameFull = connection.getOutputViewName(
        workflow.id,
        componentName,
        params,
        'out',
        WorkflowCodeType.Full
      )
      const queryFull = this.getInnerSql({
        params,
        connection,
        viewname: viewnameFull,
        codeType: WorkflowCodeType.Full
      } as WorkflowComponentCodeParams)
      viewname = viewnameDryRun
      query = dedent`${queryDryRun}\n${queryFull}`
    } else if (codeType === WorkflowCodeType.StoredProcedure) {
      const tablename = connection.getOutputTableName(workflow.id, componentName, params, 'out', codeType)
      query = this.getInnerSql({
        params,
        connection,
        tablename,
        codeType
      } as WorkflowComponentCodeParams)
    } else {
      viewname = connection.getOutputViewName(workflow.id, componentName, params, 'out', codeType)
      query = this.getInnerSql({
        params,
        connection,
        viewname,
        codeType
      } as WorkflowComponentCodeParams)
    }
    return {
      query,
      outputs: { out: viewname }
    }
  }

  getInnerSql({ params, connection, viewname, tablename, codeType }: WorkflowComponentCodeParams) {
    viewname ||= ''
    tablename ||= ''
    if (codeType === WorkflowCodeType.StoredProcedure) {
      return connection.getCreateTempTableQuery(
        tablename,
        params.source as string,
        WorkflowCodeType.StoredProcedure,
        null
      )
    } else {
      return connection.getCreateTempViewQuery(viewname, params.source as string, WorkflowCodeType.Full)
    }
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { ReadQuery }
